module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Problem-Solving",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60,55 C55.127024,55 13.3021113,55 10,55 C10,43.8366699 14.1764427,34.2923521 24.1662077,30.4365191 C23.1158447,29.284668 20.0156657,25.7830811 20.0156657,20.0223796 C20.0156657,13.3143916 25.6017125,5 35,5 C43.7435452,5 49.9338786,12.3539225 49.9338786,20.0223796 C49.9338786,26.9734701 45.8765671,30 45.8765671,30.4549123 C55.8335853,34.3226378 60,43.8543791 60,55 Z M34.2727273,11 L31.5090909,13.7636364 L32.9348155,14.3746612 C33.1627192,14.4723342 33.3699071,14.6125704 33.5452783,14.787856 C34.3070914,15.5492971 34.3073929,16.7841387 33.5459517,17.5459517 C33.3705643,17.7214248 33.1632949,17.8618077 32.9352704,17.9595643 C31.945701,18.3838035 30.7995828,17.9255128 30.3753436,16.9359435 L29.7636364,15.5090909 L27,18.2727273 L30.4909091,21.7636364 L29.0651845,22.3746612 C28.8371935,22.4723716 28.629941,22.6126884 28.4545455,22.7880839 C27.6931186,23.5495108 27.6931186,24.7840277 28.4545455,25.5454545 C28.629941,25.7208501 28.8371935,25.8611669 29.0651845,25.9588773 C30.0549384,26.3830575 31.2011585,25.9245695 31.6253388,24.9348155 L32.2363636,23.5090909 L35.7272727,27 L38.4909091,24.2363636 L37.0651845,23.6253388 C36.8371935,23.5276284 36.629941,23.3873116 36.4545455,23.2119161 C35.6931186,22.4504892 35.6931186,21.2159723 36.4545455,20.4545455 C36.629941,20.2791499 36.8371935,20.1388331 37.0651845,20.0411227 C38.0549384,19.6169425 39.2011585,20.0754305 39.6253388,21.0651845 L40.2363636,22.4909091 L43,19.7272727 L39.5090909,16.2363636 L40.9348155,15.6253388 C41.1628065,15.5276284 41.370059,15.3873116 41.5454545,15.2119161 C42.3068814,14.4504892 42.3068814,13.2159723 41.5454545,12.4545455 C41.370059,12.2791499 41.1628065,12.1388331 40.9348155,12.0411227 C39.9450616,11.6169425 38.7988415,12.0754305 38.3746612,13.0651845 L37.7636364,14.4909091 L34.2727273,11 Z",
      "id": "Combined-Shape"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd1012ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/problem_solving.vue
// module id = 666
// module chunks = 1